/**
 * Heuristic to check if flex container contains items wrapped into new line.
 * @param container
 */
export const calculateWrapping = (container: HTMLElement | null) => {
  const lastChild = container?.lastElementChild && 'offsetTop' in container.lastElementChild ? (container.lastElementChild as HTMLElement) : undefined;

  return container && lastChild ? lastChild.offsetTop !== container.offsetTop : false;
};

/**
 * Heuristic used to calculate flex row height.
 */
export const calculateRowHeight = (row: HTMLElement | null) => (row?.firstElementChild as HTMLElement | null)?.offsetHeight ?? 0;
